import { render, staticRenderFns } from "./Theory.vue?vue&type=template&id=58e34fa4&scoped=true&"
import script from "./Theory.vue?vue&type=script&lang=js&"
export * from "./Theory.vue?vue&type=script&lang=js&"
import style0 from "./Theory.vue?vue&type=style&index=0&id=58e34fa4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e34fa4",
  null
  
)

export default component.exports